import type { Profile, User } from '@shady-pines/db';
import { isNonEmptyArray, type Uuid } from '@shady-pines/types';
import { isNil, keyBy } from 'lodash';
import { useMemo } from 'react';
import { GET_PROFILE_GQL, GET_USER_PROFILES } from './queries';
import { useAutoPaginatedQuery } from './use-paginated-query';

export type UserProfile = Pick<
  Profile,
  'id' | 'name' | 'user_name' | 'role' | 'heroku_user_id' | 'device_type' | 'app_version'
>;

export const useUserProfiles = (skip?: boolean) => {
  const result = useAutoPaginatedQuery<UserProfile>(
    GET_USER_PROFILES,
    {},
    'profilesCollection',
    skip,
  );
  const value = useMemo(
    () => ({
      ...result,
      items: keyBy(result.items, 'id') as Partial<Record<Uuid<User>, UserProfile>>,
    }),
    [result],
  );

  return value;
};

export const useProfilesById = (ids: Uuid<User>[] | null | undefined, skip?: boolean) => {
  return useAutoPaginatedQuery<UserProfile, { ids: Uuid<User>[] | null | undefined }>(
    GET_PROFILE_GQL,
    { ids },
    'profilesCollection',
    skip || isNil(ids) || !isNonEmptyArray(ids),
  );
};
